import { Suspense } from 'react'

import { Spinner } from '@/Shared/ui/loader'
import { AppRouter } from '@/Shared/ui/routers'

import { GlobalProviders } from './GlobalProviders'
import './i18n'

function App(): JSX.Element {
  return (
    <Suspense fallback={<Spinner />}>
      <GlobalProviders>
        <AppRouter />
      </GlobalProviders>
    </Suspense>
  )
}

export default App
